module.exports = __webpack_public_path__ + "img/15m_sprint_card.fd11c5ca.svg";